// The storybook kit registers a global AhaButton, which would otherwise swallow the DS <aha-button> tag.
export default {
  functional: true,
  render: (h, { data, children }) => h('aha-button', { ...data, pre: true }, children),
}
